import { Monitor, ShieldCheck, Workflow } from "lucide-react";
import type { GuideSlide, GuideStep } from "@/components/training/SlideGuide";

export const S2P_NOVEMBER_STEPS: GuideStep[] = [
  {
    id: "risk",
    title: "Single-Tool Dependence",
    description: "An outage can stall work when your team depends on one AI tool.",
    duration: "90 sec",
    whyItMatters: "An AI outage can become a business outage when critical work depends on one tool.",
    actions: ["Keep critical playbooks portable and a manual path ready."],
    checkpoint: "You can name the work that would stall and demonstrate how the team would continue during an outage.",
    icon: ShieldCheck,
  },
  {
    id: "opportunity",
    title: "Owned AI vs. Rented AI",
    description: "Compare self-hosted open-source or open-weight models with rented frontier cloud models.",
    duration: "90 sec",
    whyItMatters: "Where AI runs changes what you control, pay for, and maintain.",
    actions: ["Match each workload to its data needs, capabilities, and total cost."],
    checkpoint: "You can explain who operates the model and what your team is responsible for in each approach.",
    icon: Workflow,
  },
  {
    id: "capability",
    title: "Computer Use",
    description: "AI can see the screen, click and type, and check the result.",
    duration: "90 sec",
    whyItMatters: "Once a person teaches the workflow, AI can carry out computer-based tasks.",
    actions: ["Start with one bounded task using demo data. Review before sending or changing records."],
    checkpoint: "One interface task has defined boundaries and a reviewed result.",
    icon: Monitor,
  },
];

// Four visible slides; a clean URL opens at start. No retained or hidden slides.
export const S2P_NOVEMBER_SLIDES: GuideSlide[] = [
  { id: "start", title: "New Risks, Opportunities, & Capabilities", kind: "custom", tone: "paper" },
  { id: "single-tool-dependence", title: "Single-Tool Dependence", kind: "custom", tone: "paper", stepId: "risk" },
  { id: "owned-vs-rented", title: "Owned AI vs. Rented AI", kind: "custom", tone: "paper", stepId: "opportunity" },
  { id: "computer-use", title: "Computer Use", kind: "custom", tone: "paper", stepId: "capability" },
];
